import { Switch } from "@chakra-ui/react";
import React, { memo, useCallback } from "react";
import {
  AdminEditUserMutation,
  AdminEditUserMutationVariables,
  UserFragment,
  UserRoleType,
} from "gql/graphql";
import { useMutation } from "@apollo/client";
import ADMIN_EDIT_USER_MUTATION from "../_networking/admin-edit-user";

interface IProps {
  user: UserFragment;
}

const AdminEditUserAdmin = ({ user }: IProps) => {
  const [adminEditUserMutationAPI] = useMutation<
    AdminEditUserMutation,
    AdminEditUserMutationVariables
  >(ADMIN_EDIT_USER_MUTATION);

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      adminEditUserMutationAPI({
        variables: {
          id: user.id,
          input: {
            roleType:
              e.target.checked === true
                ? UserRoleType.Admin
                : UserRoleType.User,
          },
        },
        optimisticResponse: {
          adminEditUser: {
            ...user,
            roleType:
              e.target.checked === true
                ? UserRoleType.Admin
                : UserRoleType.User,
          },
        },
      });
    },
    [adminEditUserMutationAPI, user],
  );

  return (
    <Switch
      size="sm"
      defaultChecked={user.roleType === UserRoleType.Admin}
      onChange={onChange}
    />
  );
};

export default memo(AdminEditUserAdmin);
